
import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import { ConfirmationDialog } from "components";
import { FeaturedAdsProps, stateStatusType } from "../state/actionType";
import { deleteFeaturedAds, ResetFeaturedAds } from "../state/action";

interface CategoryProps {
  onClose: ()=>void;
  featuredAdsData: FeaturedAdsProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CategoryProps;
const HandleDeleteFeaturedAds: React.FC<Props> = ({
  onClose,
  featuredAdsData,
  onDeleteFeaturedAds,
  onResetFeaturedAds
}) => {
  const [error,setError] = useState("")
   const featuredAdsState = useSelector(
    (state: any) => state.featuredAds.genericFeaturedAdsState
  );
  
  const handleDeletePackage = async (e: FormEvent) => {
    e.preventDefault();
    onDeleteFeaturedAds(featuredAdsData.id);
    onClose()
  };
     useEffect(() => {
      if (!featuredAdsState.isLoading) {
        if (featuredAdsState.error) {
          setError(featuredAdsState.error);
        } else if (featuredAdsState.status === stateStatusType.SUCCESS) {
          onClose();
          onResetFeaturedAds(); 
        } else {
          setError('');
        }
      }
    }, [featuredAdsState.isLoading, featuredAdsState.error, featuredAdsState.status]);
  return (
    <>
      <ConfirmationDialog
        title={`Delete ${featuredAdsData.name}`}
        message={"Are you sure you want to delete this Featured Ads?"}
        onConfirm={handleDeletePackage}
        onCancel={onClose}
        error={error}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteFeaturedAds: (ad_id: string) => dispatch(deleteFeaturedAds(ad_id)),
   onResetFeaturedAds: () => dispatch(ResetFeaturedAds()),
});

export default connect(null, mapDispatchToProps)(HandleDeleteFeaturedAds);
